import React from 'react'
import { JumpRow } from '../atoms'
import { BoxProps, Columns } from '../../design-system'

export const ContentBar = ({ children, ...boxProps }: BoxProps) => (
  <JumpRow {...boxProps}>
    <Columns justifyContent="space-between">{children}</Columns>
  </JumpRow>
)
